var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 4.99984V7.0165C18.332 8.33317 17.4987 9.1665 16.182 9.1665H13.332V3.3415C13.332 2.4165 14.0904 1.6665 15.0154 1.6665C15.9237 1.67484 16.757 2.0415 17.357 2.6415C17.957 3.24984 18.332 4.08317 18.332 4.99984Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83317V17.4998C1.66797 18.1915 2.4513 18.5832 3.0013 18.1665L4.4263 17.0998C4.75964 16.8498 5.2263 16.8832 5.5263 17.1832L6.90964 18.5748C7.23464 18.8998 7.76797 18.8998 8.09297 18.5748L9.49297 17.1748C9.78463 16.8832 10.2513 16.8498 10.5763 17.0998L12.0013 18.1665C12.5513 18.5748 13.3346 18.1832 13.3346 17.4998V3.33317C13.3346 2.4165 14.0846 1.6665 15.0013 1.6665H5.83464H5.0013C2.5013 1.6665 1.66797 3.15817 1.66797 4.99984V5.83317Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 11.4416L9.77656 6.8916",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93553 11.2502H9.94301",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16209 7.08317H5.16957",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons2);
export default __webpack_public_path__ + "static/media/coupons2.95ea3ae1454467755c8eb8a866939b52.svg";
export { ForwardRef as ReactComponent };